import NotificationMixin from "@/components/mixins/NotificationMixin";

export default {
  mixins: [NotificationMixin],
  data() {
    return {
      model: null,
      apiModel: null,
      not_found: false,
      loading: false,
      formReferences: [
        'form',
        'additional',
      ],
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  created () {
    this.fetch(this.id)
  },
  methods: {
    async fetch(id) {
      try {
        const { data } = await this.$api[this.apiModel].get(id);
        this.model = {
          ...data.data,
        }
      } catch (e) {
        console.error(e)
      } finally {
        if (!this.model) {
          this.not_found = true
        }
      }
    },
    getParams() {
      let params = new FormData();
      params.set('_method', 'post');

      for (const field in this.model) {
        params.set(field, this.model[field]);
      }

      // Append extra vars here
      if (this.model.hasOwnProperty("File") && !this.model.hasOwnProperty("IsActiveDocument")) {
        params.append('IsActiveDocument', 0);
      }

      if (this.references) {
        this.setReferences(this.references, null, params);
      }

      return params;
    },
    /**
     *  This ensures it will do a deep clone copy
     * @param force
     * @returns object
     */
    getModelCopy(force = false) {
      if (!this.modelCopy || force) {
        this.modelCopy = JSON.parse(JSON.stringify(this.model))
      }

      return this.modelCopy;
    },
    /**
     * Sets references, or dropdowns to be the ID
     * @param params
     * @param references
     */
    setReferences(references, object = null, params) {
      const model = object || this.getModelCopy();
      references.forEach((ref) => params.set(ref,this.getReferenceId(ref, model)))
    },
    /**
     * Retrieve an ID field from an object
     * @param fieldName
     * @param object
     * @returns {null}
     */
    getReferenceId(fieldName, object = null) {
      if (!object) {
        object = this.getModelCopy();
      }

      if (!object[fieldName]) {
        return null;
      }

      return object[fieldName].id || null;
    },
    async save() {
      this.loading = true;

      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        this.loading = false;

        return false;
      }

      const params = this.getParams();

      try {
        await this.$api[this.apiModel].update(this.id, params);
        this.notifySuccess('Document updated');
        this.$router.back();
      } catch (e) {
        const response = e.response;
        let errorMessage = 'An error occurred'

        if (response.data.errors
          && response.data.errors.File
        ) {
          errorMessage = response.data.errors.File[0];
        }

        this.notifyError(errorMessage);
      } finally {
        this.loading = false;
      }
    }
  },
};
